import { createAction, props } from "@ngrx/store";
import {CartRequestDetails} from "../../../../@domain/cart-request-details";

export const ADD_FOOD_TO_CART = createAction('[PLACE ORDER] ADD_FOOD_TO_CART', props<{payload: CartRequestDetails}>())
export const DELETE_FOOD_FORM_CART = createAction('[PLACE ORDER] DELETE_FOOD_FORM', props<{payload:CartRequestDetails}>())
export const ADD_PRINTED_FOODS_TO_CART = createAction('[PLACE ORDER] ADD_PRINTED_FOODS_TO_CART', props<{payload: CartRequestDetails[]}>());
export const UPDATE_CART_ITEM_NAMES = createAction('[PLACE ORDER] UPDATE_CART_ITEM_NAMES', props<{payload: Map<string, string>}>());
export const CLEAR_CART = createAction('[PLACE ORDER] CLEAR_CART');
